module.exports = __webpack_public_path__ + "static/media/p200-tip-box.694aee53.svg";